import React from 'react';
import { translate } from 'react-i18next';
import { Tab, Tabs } from 'react-bootstrap';
import ACCentralDataTable from './ACCentralDataTable';
import BoilerDataTable from './BoilerDataTable';
import HeatPumpDataTable from './HeatPumpDataTable';
import SolarEnergyDataTable from './SolarEnergyDataTable';
import HeatToElectricalEnergyDataTable from './HeatToElectricalEnergyDataTable';
import OtherRenewableEnergyDataTable from './OtherRenewableEnergyDataTable';

export class BuildingComponent extends React.Component {
  render() {
    const { t, building } = this.props;
    return (
      <Tabs
        id="building-component-tabs"
        onSelect={key => this.setState({ tabActiveKey: key })}
        mountOnEnter={true}
      >
        <Tab eventKey={2} title={t('a/c central')}>
          <ACCentralDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
        <Tab eventKey={3} title={t('boiler')}>
          <BoilerDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
        <Tab eventKey={4} title={t('heat pump')}>
          <HeatPumpDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
        <Tab eventKey={5} title={t('solar energy')}>
          <SolarEnergyDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
        <Tab eventKey={6} title={t('heat to electrical energy')}>
          <HeatToElectricalEnergyDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
        <Tab eventKey={7} title={t('other renewable energy')}>
          <OtherRenewableEnergyDataTable buildingId={building.id} projectId={building.project_id}/>
        </Tab>
      </Tabs>
    );
  }
}

export default translate('translations', { withRef: true })(BuildingComponent);



// WEBPACK FOOTER //
// ./src/components/project_detail/BuildingComponent.js